import React, {useState, useEffect} from 'react'
import StaticOverviewTable from "./datas/StaticOverviewTable"
import moment from "moment"
import {Button} from "antd"
import {CloudUploadOutlined} from '@ant-design/icons'
import {statisticUserAction, getExportStatisticUserAction} from "../../../services/api/apiOrdersReport"
import UseDebounce from "../../helpers/UseDebounce"
import StaticOverviewFilters from "./filters/StaticOverviewFilters"
import NextPagination from "../../../components/Pagination/NextPagination"
import downloadFile from '../../../share/downloadFile'

function StaticOverviewPage() {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [name, setName] = useState('')
    const [selectedDate, setSelectedDate] = useState([moment().subtract(7, 'd'), moment()])
    const [dateFilter, setDateFilter] = useState({
        from: moment().subtract(7, 'd').format('DD/MM/YYYY HH:mm:ss'),
        to: moment().format('DD/MM/YYYY HH:mm:ss')
    })
    const [page, setPage] = useState(1)
    const [limit] = useState(50)
    const [total, setTotal] = useState(0)
    const [statics, setStatics] = useState([])

    const _convertString = (string) => {
        const regex = /,\s|,|\n/
        const parsed = string.split(regex)

        return !!parsed && parsed.length > 0 && parsed.filter(item => item !== "")
    }

    const _handleChangeName = (value) => {
        const parseValue = _convertString(value)

        setName(parseValue)
        setPage(1)
    }

    const _onChangeDate = (dateString) => {
        setDateFilter(dateString)
        setPage(1)
    }

    const _onChangeSelectedDate = (value) => {
        setSelectedDate(value)
        setPage(1)
    }

    const _fetchStaticOverview = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page,
                limit,
                user: name,
                created: dateFilter
            }
            const {data: response} = await statisticUserAction(payload)

            const {success, data, message} = response

            if (!success) {
                setLoading(false)

                return setError(message)
            }

            setLoading(false)
            setStatics(data.users)
            setTotal(data.total)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _exportStaticsUseAction = async () => {
        const query = {
            user: name,
            created: dateFilter
        }

        const { data } = await getExportStatisticUserAction(query)

        downloadFile(data, { filename: `user-actions-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
    }

    const _handleChangePage = (page) => {
        setPage(page)
    }

    const debouncedName = UseDebounce(name, 1000)

    useEffect(() => {
        _fetchStaticOverview()
        // eslint-disable-next-line
    }, [debouncedName, dateFilter, page])

    return (
        <div className='StaticOverviewPage'>
            <div className="Section">
                <div className="heading">
                    <h3>Statics Overview</h3>
                    <Button type="primary" icon={<CloudUploadOutlined/>} onClick={_exportStaticsUseAction}>
                        Export data
                    </Button>
                </div>
                <div className="Content">
                    <div className="Filters">
                        <StaticOverviewFilters
                            name={name}
                            selectedDate={selectedDate}
                            onChangeSelectedDate={_onChangeSelectedDate}
                            onChangeName={_handleChangeName}
                            onChangeDateFilter={_onChangeDate}
                        />
                    </div>

                    <div className="ContentData">
                        <StaticOverviewTable loading={loading} error={error} statics={statics}/>

                        <div className="Footer">
                            <div className="Total">{`Hiển thị ${statics.length} bản ghi trên ${total} bản ghi`}</div>
                            <div className="Pagination">
                                <NextPagination
                                    limit={limit}
                                    total={total}
                                    page={page}
                                    onChange={_handleChangePage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StaticOverviewPage
